import React, { useEffect, useState, useCallback } from "react";
import { RiDeleteBin5Line, } from "react-icons/ri";
import { CiSquarePlus } from "react-icons/ci";
import Select, { components } from "react-select"
import { FaRegFileLines, FaRegShareFromSquare } from "react-icons/fa6";
import { FaFileExport } from "react-icons/fa6";
import { Table } from 'rsuite';
import { masterCategories, childCategories, childGeneralInfoCols, primarySuppliers, stringOperators, numberAsStringsOperators, booleans, currencyType, numberOperators, customerOrPartner, generalInfoCols, cardAcceptanceInfoCol, inSequenceInfoCol, listsupplierCategories, listSupInfoCols, dateOperators, tableColumnHeaders, matchedCardAcceptanceInfoCol, booleansWithoutNull, qaState, bulkUpdateMasterColumns, bulkUpdateChildColumns, bulkUpdateMasterColumnsValues, bulkUpdateChildColumnsValues } from "../../utils/constants/reportFilters";
import { useDispatch, useStore } from 'react-redux'
import { getAllPartners } from "../../redux/actions/partner";
import { getAllContactsByIds, getCustomerNames } from "../../redux/actions/vendor";
import { createChildSupplierReport, createListSupplierReport, createMasterSupplierReport, getMySharedReports, getSavedReportById, getSavedReports, saveReport, shareReport } from "../../redux/actions/report";
import LoaderComponent from "../CommonComponents/LoaderComponent";
import ExportReport from "./exportReport";
import { CiMenuKebab } from "react-icons/ci";
import { toast } from "../CommonComponents/ToastComponent/toast";
import ModalComponent from "../CommonComponents/Modal";
import { checkIsAdmin, updateReportFeesColumn } from "../../services/helper";
import { useLocation } from 'react-router-dom';
import QaNotesModal from "../QualityComponent/modals/qa-notes-modal";
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { FaQuestionCircle } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom/cjs/react-router-dom";
import VendorExportModal from "../AssignVendorComponent/modals/export-modal";
import { useHistory } from 'react-router-dom';
import moment from "moment";

const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, col, dataKey, onClick, ...props }) => {
    return (
        <Cell {...props} className="table-link">
            {rowData[dataKey] === null ? 'unknown' : rowData[dataKey] === true ? 'Yes' : 'No'}
        </Cell>
    )
}

const CustomOption = (props) => {
    return (
        <components.Option {...props}>
            {props.data.label}
            {props.data.value === 'creditCardCondition' && (
                <span style={{ float: 'right' }}>
                    <button type="button" data-bs-toggle="tooltip" data-bs-placement="right" title="The logic looks at CC processing, Incremental, Variable, and the min/max fees.">
                        <FaQuestionCircle color="#1776e8" size={18} />
                    </button>
                </span>
            )}

            {props.data.value === 'isAcceptAllCreditCards' && (
                <span style={{ float: 'right' }}>
                    <button type="button" data-bs-toggle="tooltip" data-bs-placement="right" title="The logic looks at American Express, Mastercard and Visa Credit Card acceptance.">
                        <FaQuestionCircle color="#1776e8" size={18} />
                    </button>

                </span>
            )}
        </components.Option>
    );
};

const CustomCell = ({ rowData, col, dataKey, contacts, primarySupplier, ...props }) => {
    const phoneColumns = ['phone', 'childSupplierPhone', 'listSupplierPhone', 'cardPaymentByPhoneValue', 'cardPaymentIVRPhone']
    const emailColumns = ['email', 'childSupplierEmail', 'listSupplierEmail', 'mastersPaymentEmailAch', 'creditCardPaymentEmail', 'creditCardRemittanceEmail']
    if (col.value === 'userId') {
        return (
            <Cell {...props} className="table-link" title={rowData['Added By User']}>
                {rowData['Added By User']}
            </Cell>
        )
    }
    if ((col?.value === "suppliername" || col?.value === "childSupplierName") && (primarySupplier && (primarySupplier[0]?.value === "masterSupplier" || primarySupplier[0]?.value === "childSupplier"))) {
        return (
            <Cell {...props} className="table-link">
                <a href={col.value === "suppliername" ? `/suppliers/${rowData.masterSupplierId}` : col.value === "childSupplierName" ? `/suppliers/relatedsupplier/${rowData.childSupplierId}` : rowData.url
                } target="_blank">
                    {rowData[dataKey]}
                </a>
            </Cell>
        );
    }
    if (col.value === "isAcceptAllCreditCards") {
        if (rowData['isAcceptMasterCard'] === true && rowData['isAcceptVisa'] === true && rowData['isAcceptAmericanExpress'] === true) {
            return (
                <Cell {...props} className="table-link" title="Yes">
                    Yes
                </Cell>
            )
        } else if (rowData['isAcceptMasterCard'] === false && rowData['isAcceptVisa'] === false && rowData['isAcceptAmericanExpress'] === false) {
            return (
                <Cell {...props} className="table-link" title="No">
                    No
                </Cell>
            )
        } else if (rowData['isAcceptMasterCard'] === null && rowData['isAcceptVisa'] === null && rowData['isAcceptAmericanExpress'] === null) {
            return (
                <Cell {...props} className="table-link" title="Unknown">
                    Unknown
                </Cell>
            )
        } else {
            var value = typeof rowData?.[dataKey] === 'boolean' ? (rowData?.[dataKey] === true ? "Yes" : "false") : rowData?.[dataKey]
            return (
                <Cell {...props} className="table-link" title={value}>
                    {value}
                </Cell>
            )
        }
    }

    if (col.value === "approvedByQA") {
        var value = rowData['masterQaStatus'] === 8 ? "Approved" : rowData['masterQaStatus'] === 7 ? "Rejected" : rowData['masterQaStatus'] === 9 ? "In Calls" : "Pending"
        return (
            <Cell {...props} className="table-link" title={value}>
                {value}
            </Cell>
        )
    }

    if (col.value === "childSupplierDetailApprovedByQA") {
        var value = rowData['childQaStatus'] === 8 ? "Approved" : rowData['childQaStatus'] === 7 ? "Rejected" : "Pending"
        return (
            <Cell {...props} className="table-link" title={value}>
                {value}
            </Cell>
        )
    }

    if (col.value === "listSupplierApprovedByQA") {
        var value = rowData['listSupplierApprovedByQA'] === 8 ? "Approved" : rowData['listSupplierApprovedByQA'] === 7 ? "Rejected" : "Pending"
        return (
            <Cell {...props} className="table-link" title={value}>
                {value}
            </Cell>
        )
    }

    if (col.value === "cashPaymentDiscount") {
        return (
            <Cell {...props} className="table-link" title={rowData['Cash Payment Discount']}>
                {rowData['Cash Payment Discount']}
            </Cell>
        )
    }

    if (col.value === "creditCardCondition") {
        if (
            (rowData['amexProcessingFeeValue'] === "" || rowData['amexProcessingFeeValue'] === null) &&
            (rowData['visaProcessingFeeValue'] === "" || rowData['visaProcessingFeeValue'] === null) &&
            (rowData['mastercardProcessingFeeValue'] === "" || rowData['mastercardProcessingFeeValue'] === null) &&
            (rowData['amexIncrementalFeeValue'] === "" || rowData['amexIncrementalFeeValue'] === null) &&
            (rowData['visaIncrementalFeeValue'] === "" || rowData['visaIncrementalFeeValue'] === null) &&
            (rowData['mastercardIncrementalFeeValue'] === "" || rowData['mastercardIncrementalFeeValue'] === null) &&
            (rowData['isAcceptAmexVariableFee'] === null) &&
            (rowData['isAcceptVisaVariableFee'] === null) &&
            (rowData['isAcceptMasterCardVariableFee'] === null) &&
            (rowData['amexMinPaymentFeeValue'] === "" || rowData['amexMinPaymentFeeValue'] === null) &&
            (rowData['amexMaxPaymentFeeValue'] === "" || rowData['amexMaxPaymentFeeValue'] === null) &&
            (rowData['visaMinPaymentFeeValue'] === "" || rowData['visaMinPaymentFeeValue'] === null) &&
            (rowData['visaMaxPaymentFeeValue'] === "" || rowData['visaMaxPaymentFeeValue'] === null) &&
            (rowData['mastercardMinPaymentFeeValue'] === "" || rowData['mastercardMinPaymentFeeValue'] === null) &&
            (rowData['mastercardMaxPaymentFeeValue'] === "" || rowData['mastercardMaxPaymentFeeValue'] === null)
        ) {
            return (
                <Cell {...props} className="table-link" title="False">
                    False
                </Cell>
            )
        } else if (
            (rowData['amexProcessingFeeValue'] !== "" && rowData['amexProcessingFeeValue'] !== null) ||
            (rowData['visaProcessingFeeValue'] !== "" && rowData['amexProcessingFeeValue'] !== null) ||
            (rowData['mastercardProcessingFeeValue'] !== "" && rowData['mastercardProcessingFeeValue'] !== null) ||
            (rowData['amexIncrementalFeeValue'] !== "" && rowData['amexIncrementalFeeValue'] !== null) ||
            (rowData['visaIncrementalFeeValue'] !== "" && rowData['visaIncrementalFeeValue'] !== null) ||
            (rowData['mastercardIncrementalFeeValue'] !== "" && rowData['mastercardIncrementalFeeValue'] !== null) ||
            (rowData['isAcceptAmexVariableFee'] !== null) ||
            (rowData['isAcceptVisaVariableFee'] !== null) ||
            (rowData['isAcceptMasterCardVariableFee'] !== null) ||
            (rowData['amexMinPaymentFeeValue'] !== "" && rowData['amexMinPaymentFeeValue'] !== null) ||
            (rowData['amexMaxPaymentFeeValue'] !== "" && rowData['amexMaxPaymentFeeValue'] !== null) ||
            (rowData['visaMinPaymentFeeValue'] !== "" && rowData['visaMinPaymentFeeValue'] !== null) ||
            (rowData['visaMaxPaymentFeeValue'] !== "" && rowData['visaMaxPaymentFeeValue'] !== null) ||
            (rowData['mastercardMinPaymentFeeValue'] !== "" && rowData['visaMaxPaymentFeeValue'] !== null) ||
            (rowData['mastercardMaxPaymentFeeValue'] !== "" && rowData['mastercardMaxPaymentFeeValue'] !== null)
        ) {
            return (
                <Cell {...props} className="table-link" title="True">
                    True
                </Cell>
            )
        }
    }

    if (col.value === "lastCalledDate") {
        const lastCalledDate = rowData?.['lastCalledDate'] ? moment(rowData?.['lastCalledDate']).format('MM/DD/YYYY') : '';
        return (
            <Cell {...props} className="table-link" title={rowData['Cash Payment Discount']}>
                {lastCalledDate}
            </Cell>
        )
    }

    if (phoneColumns?.includes(col?.value)) {
        const tmpValue = rowData?.[dataKey] || ''
        const value = tmpValue && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpValue) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(tmpValue) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(tmpValue) && /^\d+$/.test(tmpValue)) && /^\d+$/.test(tmpValue) ? contacts?.find(data => data?.id === parseInt(tmpValue))?.phone : (tmpValue || '')
        return (
            <Cell {...props} className="table-link" title={value}>
                {value}
            </Cell>
        )
    }

    if (emailColumns?.includes(col?.value)) {
        const tmpValue = rowData?.[dataKey] || ''
        const value = tmpValue && /^\d+$/.test(tmpValue) && /^\d+$/.test(tmpValue) ? contacts?.find(data => data?.id === parseInt(tmpValue))?.email : (tmpValue || '')
        return (
            <Cell {...props} className="table-link" title={value}>
                {value}
            </Cell>
        )
    }

    return (
        <Cell {...props} className="table-link" title={typeof rowData?.[dataKey] === 'boolean' ? (rowData?.[dataKey] === true ? "Yes" : "false") : rowData?.[dataKey]}>
            {typeof rowData?.[dataKey] === 'boolean' ? (rowData?.[dataKey] === true ? "Yes" : "false") : rowData?.[dataKey]}
        </Cell>
    )
};

const CustomReport = () => {
    const store = useStore().getState()
    const { auth: { user }, domain: { currentDomain } } = store
    const { state, pathname } = useLocation();
    const history = useHistory();
    const { isSharedReport } = state || {};
    let tmpReportId = pathname.split('/')[2]
    const reportIdFromURL = parseInt(tmpReportId)
    const isAdmin = checkIsAdmin(currentDomain)

    const [optionsList, setOptionsList] = useState([])
    const [selectedOptionList, setSelectedOptionList] = useState([])
    let [noOfFilters, setNoOfFilters] = useState(1);
    let [filterList, setFilterList] = useState([{ filterId: noOfFilters }])
    const [userInput, setUserInput] = useState('')
    const [currencyInput, setCurrencyInput] = useState('')
    const [selectedPartnerOrCustomer, setSelectedPartnerOrCustomer] = useState([])
    const [selectedPartnerList, setSelectedPartnerList] = useState([])
    const [selectedCustomerList, setSelectedCustomerList] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [partners, setPartners] = useState([])
    const [tableColHeaders, setTableColHeaders] = useState([])
    const [tmpTableColHeaders, setTmpTableColHeaders] = useState([])

    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [offset, setOffSet] = useState(0)
    const [totalRecords, setTotalRecords] = useState(0)
    const [exportHeader, setHeaderExport] = useState([])
    const [result, setResult] = useState([])
    const [reportContacts, setReportContacts] = useState([])
    const [loader, setLoader] = useState(false)
    const [openReportPopup, setopenReportPopup] = useState(true)
    const [active, setActive] = useState('generalInfo')
    const [inSequenceCheckedItems, setInSequenceCheckedItems] = useState({});
    const [visibleReportHeaders, setVisibleReportHeaders] = useState([])
    const [tmpVisibleReportHeaders, setTmpVisibleReportHeaders] = useState([])

    const [genInfoCols, setGenInfoCols] = useState([])
    const [childInfoCols, setChildInfoCols] = useState([])
    const [listSupplierInfoCols, setListSupplierInfoCols] = useState([])
    const [cardAccInfoCols, setCardAccInfoCols] = useState([])

    const [prevGenInfoCols, setPrevGenInfoCols] = useState([])
    const [prevChildInfoCols, setPrevChildInfoCols] = useState([])
    const [prevListSupplierInfoCols, setPrevListSupplierInfoCols] = useState([])
    const [prevCardAccInfoCols, setPrevCardAccInfoCols] = useState([])
    const [masterSupCardAccInfoCols, setMasterSupCardAccInfoCol] = useState([])
    // const [seqInfoCols, setSeqInfoCols] = useState(inSequenceInfoCol)
    const [searchTerm, setSearchTerm] = useState('')
    const [primarySupplier, setPrimarySupplier] = useState(null) //masterSupplier //childSupplier //listSupplier
    const [xPos, setXPos] = useState(0)
    const [yPos, setYPos] = useState(0)
    const [cardAcceptanceTab, setCardAcceptanceTab] = useState('')
    const [showPartnerList, setShowPartnerList] = useState(false)
    const [showDialog, setShowDialog] = useState(false)
    const [backdrop, setBackdrop] = useState('static');
    const [reportName, setReportName] = useState('')
    const [finalFilter, setFinalFilter] = useState([])
    const [subGeneralBtnActive, setSubGeneralBtnActive] = useState('')
    const [showShareModal, setShowShareModal] = useState(false)
    const [savedReportId, setSavedReportId] = useState(null)
    const [savedReport, setSavedReport] = useState({})
    const [savedReportsModal, setSavedReportsModal] = useState(false)
    const [allReports, setAllReports] = useState([])
    const [sharedToMe, setSharedToMe] = useState([])
    const [sharedReportSelected, setSharedReportSelected] = useState(false)
    const [myReportsSelected, setMyReportsSelected] = useState(true)
    const [exportData, setExportData] = useState([])
    const [exportModal, setExportModal] = useState(false)
    const [headerModal, setHeaderModal] = useState(false)
    const [savedPartnerOrCustomer, setSavedPartnerOrPartner] = useState([])
    const [partnerList, setPartnerList] = useState([])
    const [customerList, setCustomerList] = useState([])
    const [savedPrimarySupplier, setSavedPrimarySupplier] = useState(null)
    const [bulkUpdateSupplier, setBulkUpdateSupplier] = useState('')
    const [selectedReportTab, setSelectedReportTab] = useState('saved')

    const tmpGeneralInfoCols = generalInfoCols.map(info => ({ ...info }));
    const tmpChildGeneralInfoCols = childGeneralInfoCols.map(info => ({ ...info }))
    const tmpListSupplierInfoCols = listSupInfoCols.map(info => ({ ...info }))
    const tmpCardAcceptanceInfoCol = cardAcceptanceInfoCol.map(info => ({ ...info }))

    useEffect(() => {
        setTableColHeaders(tableColumnHeaders)
        setTmpTableColHeaders(tableColumnHeaders)
        setGenInfoCols(generalInfoCols)
        setChildInfoCols(childGeneralInfoCols)
        setListSupplierInfoCols(listSupInfoCols)
        setCardAccInfoCols(cardAcceptanceInfoCol)
        setCardAcceptanceTab('listSupplier')
        setSubGeneralBtnActive('master')
        getSavedReportsData(limit, offset)
    }, [])


    const onSelectedHeaders = async () => {
        setPrevGenInfoCols(genInfoCols.map(info => ({ ...info })))
        setPrevChildInfoCols(childInfoCols.map(info => ({ ...info })))
        setPrevCardAccInfoCols(cardAccInfoCols.map(info => ({ ...info })))
        setPrevListSupplierInfoCols(listSupplierInfoCols.map(info => ({ ...info })))
        setTmpVisibleReportHeaders(visibleReportHeaders)
        setTmpTableColHeaders(tableColHeaders)
        onCloseReportHeaderConfirmation()
        await onRun(1, limit, offset, primarySupplier[0]?.value, savedReportId, selectedPartnerOrCustomer, filterList, [], false, genInfoCols, childInfoCols, listSupplierInfoCols, cardAccInfoCols, selectedPartnerList, selectedCustomerList)
    }

    const onCloseReportHeader = () => {
        setHeaderModal(true)
    }

    const onCloseReportHeaderConfirmation = () => {
        setHeaderModal(false)
        setopenReportPopup(!openReportPopup)
        setSearchTerm('')
    }

    const onNotselectedHeaders = async () => {
        setHeaderModal(false)
        setopenReportPopup(!openReportPopup)
        setSearchTerm('')
        setGenInfoCols(prevGenInfoCols.map(info => ({ ...info })))
        setChildInfoCols(prevChildInfoCols.map(info => ({ ...info })))
        setCardAccInfoCols(prevCardAccInfoCols.map(info => ({ ...info })))
        setListSupplierInfoCols(prevListSupplierInfoCols.map(info => ({ ...info })))
        setVisibleReportHeaders(tmpVisibleReportHeaders.map(info => ({ ...info })))
        setTableColHeaders(tmpTableColHeaders.map(info => ({ ...info })))
    }

    const getSavedReportsDataById = useCallback(async (reportId) => {
        await dispatch(getSavedReportById(reportId)).then(res => {
            const result = {
                createdAt: res[0]?.createdAt,
                createdBy: res[0]?.createdBy,
                customerName: JSON?.parse(res[0]?.customerName),
                filters: JSON?.parse(res[0]?.filters),
                id: res[0]?.id,
                partnerId: JSON?.parse(res[0]?.partnerId),
                primarySupplier: res[0]?.primarySupplier,
                reportHeaders: res[0]?.reportHeaders && JSON?.parse(res[0]?.reportHeaders),
                title: res[0]?.title,
                updatedAt: res[0]?.updatedAt
            }

            let tmpPartnerOrCustomer = []
            let tmpSelectedCustomerList = []
            let tmpSelectedPartnerList = []

            if (result?.customerName?.length > 0 || (result?.partnerId && result?.partnerId?.length > 0)) {
                setShowPartnerList(true)
                if (result?.customerName.length > 0) {
                    tmpPartnerOrCustomer.push({ label: "Customer", value: "customer" })
                    tmpSelectedCustomerList = result?.customerName
                    setSelectedCustomerList(result?.customerName)
                } else {
                    setSelectedCustomerList([])
                }
                if (result?.partnerId.length > 0) {
                    tmpPartnerOrCustomer.push({ label: "Partner", value: "partner" })
                    tmpSelectedPartnerList = result?.partnerId
                    setSelectedPartnerList(result?.partnerId)
                } else {
                    setSelectedPartnerList([])
                }
            } else {
                setShowPartnerList(false)
                setSelectedCustomerList([])
                setSelectedPartnerList([])
            }
            setSavedPartnerOrPartner(tmpPartnerOrCustomer)
            setSelectedPartnerOrCustomer(tmpPartnerOrCustomer)
            let resultWithoutPopUp = [...result?.reportHeaders]
            setSavedReport(result)
            setSavedPrimarySupplier(primarySuppliers?.filter(sup => sup?.value === result?.primarySupplier))
            if (result?.primarySupplier === "listSupplier") {
                setOptionsList(listsupplierCategories)
            } else if (result?.primarySupplier === "masterSupplier") {
                setOptionsList(masterCategories)
            } else if (result?.primarySupplier === "childSupplier") {
                setOptionsList(childCategories)
            }
            const masterHeaders = result?.reportHeaders?.filter(item => item.mainCategory === 'master')
            const childHeaders = result?.reportHeaders?.filter(item => item.mainCategory === 'child')
            const cardAccHeaders = result?.reportHeaders?.filter(item => item.cat === 'cardAcceptance' || item.cat === 'payments' || item.cat === 'cardAcceptanceEmails')
            const listSupHeaders = result?.reportHeaders?.filter(item => item.cat === 'listSupplier' || item.cat === 'listSupplierDetails')
            // const tmpGenInfoCols = tmpGeneralInfoCols?.map(col => )
            const tmpGenInfoColsArray = [...tmpGeneralInfoCols, ...masterHeaders];
            const tmpGenInfoCols = [...tmpGenInfoColsArray.reduce((map, obj) => map.set(obj.value, obj), new Map()).values()];

            const tmpChildGenInfoColsArray = [...tmpChildGeneralInfoCols, ...childHeaders];
            const tmpChildGenInfoCols = [...tmpChildGenInfoColsArray.reduce((map, obj) => map.set(obj.value, obj), new Map()).values()];

            const tmpCardAccInfoColsArray = [...tmpCardAcceptanceInfoCol, ...cardAccHeaders];
            const tmpCardAccInfoCols = [...tmpCardAccInfoColsArray.reduce((map, obj) => map.set(obj.value, obj), new Map()).values()];

            const tmpListSupColsArray = [...tmpListSupplierInfoCols, ...listSupHeaders];
            const tmpListSupInfoCols = [...tmpListSupColsArray.reduce((map, obj) => map.set(obj.value, obj), new Map()).values()];

            setGenInfoCols(tmpGenInfoCols)
            setPrevGenInfoCols(tmpGenInfoCols)
            setChildInfoCols(tmpChildGenInfoCols)
            setPrevChildInfoCols(tmpChildGenInfoCols)
            setListSupplierInfoCols(tmpListSupInfoCols)
            setPrevListSupplierInfoCols(tmpListSupInfoCols)
            setCardAccInfoCols(tmpCardAccInfoCols)
            setPrevCardAccInfoCols(tmpCardAccInfoCols)
            setPrimarySupplier(primarySuppliers?.filter(sup => sup?.value === result?.primarySupplier))
            setFilterList(result?.filters)
            setReportName(result?.title)
            setVisibleReportHeaders(result?.reportHeaders.filter(header => header?.value !== "popUp"))
            setTmpVisibleReportHeaders(result?.reportHeaders.filter(header => header?.value !== "popUp"))
            setTableColHeaders(result?.reportHeaders)
            setTmpTableColHeaders(result?.reportHeaders)
            // setGenInfoCols()
            onRun(page, limit, offset, result?.primarySupplier, tmpReportId, tmpPartnerOrCustomer, result?.filters, resultWithoutPopUp, false, tmpGenInfoCols, tmpChildGenInfoCols, tmpListSupInfoCols, tmpCardAccInfoCols, tmpSelectedPartnerList, tmpSelectedCustomerList)

            if (!isSharedReport) {
                setSavedReportId(result?.id)
            }
        }).catch(err => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Get the report'
            })
        })
    }, [])

    useEffect(() => {
        if (reportIdFromURL) {
            getSavedReportsDataById(reportIdFromURL)
        }
    }, [reportIdFromURL])

    useEffect(() => {
        !primarySupplier ? setOptionsList([]) : primarySupplier[0]?.value === "listSupplier" ? setOptionsList(listsupplierCategories) : primarySupplier[0]?.value === "masterSupplier" ? setOptionsList(masterCategories) : setOptionsList(childCategories)
        setFilterList([{ filterId: 1 }])
    }, [primarySupplier])

    const dispatch = useDispatch()

    const onCardAcceptanceTabChange = (tab) => {
        setCardAcceptanceTab(tab)
        if (tab == 'listSupplier') {
            setCardAccInfoCols(cardAcceptanceInfoCol)
            setMasterSupCardAccInfoCol([])
        } else {
            setMasterSupCardAccInfoCol(matchedCardAcceptanceInfoCol)
            setCardAccInfoCols([])
        }
    }

    const onShare = () => {
        if (savedReportId === null) {
            toast.show({
                title: 'Warning',
                description: 'Please Save The Report'
            })
            return
        }
        setShowShareModal(true)
    }

    const onTabChange = (tab) => {
        setSearchTerm('')
        if (tab === "cardAcceptances") {
            setSubGeneralBtnActive('cardAcceptance')
            setActive('cardAcceptances')
        }
        if (tab === "generalInfo") {
            setSubGeneralBtnActive('master')
            setActive('generalInfo')
        }

        let tmpCardAcceptanceInfoCols = [...cardAccInfoCols]
        setCardAccInfoCols(tmpCardAcceptanceInfoCols)
    }

    const onSearch = (e) => {
        const searchItem = e.target.value
        setSearchTerm(searchItem)
    }

    const addOrRemoveTableColHeaderAndVisibleReportHeader = (item, checked) => {
        if (checked) {
            let selectedVisibleChildCol = visibleReportHeaders.filter(header => header.cat === "child")
            let tmpTableColHeader = tableColHeaders.filter(header => header.value !== "popUp")
            let obj = {}
            if (selectedVisibleChildCol.length === 0) {
                obj = { label: item.label, name: item.value, value: item.value }
                tmpTableColHeader.push(obj)
            } else {
                const checkItemIsExist = selectedVisibleChildCol.findIndex(col => col.value === item.value)
                if (checkItemIsExist === -1) {
                    obj = { label: item.label, name: item.value, value: item.value }
                    tmpTableColHeader.push(obj)
                }
            }

            setTableColHeaders(tmpTableColHeader)

            let tmp = [...visibleReportHeaders]
            tmp.push(item)
            setVisibleReportHeaders(tmp)
        } else {
            let tmpTableColHeader = tableColHeaders.filter(header => header.value !== item.value)
            setTableColHeaders(tmpTableColHeader)

            let tmp = visibleReportHeaders.filter(header => header.value !== item.value)
            setVisibleReportHeaders(tmp)
        }
    }

    const handleCheckboxChange = (event, item, tab) => {
        const { name, checked } = event.target;
        if (tab === 'visible') {
            let tmpVisibleReportHeaders = visibleReportHeaders.filter(header => header.value !== item.value)
            setVisibleReportHeaders(tmpVisibleReportHeaders)
            let tmpSupplierInfoCols = []
            if (item.cat === 'master' || item.cat === 'supplierDetails') {
                const tmpGenCols = [...genInfoCols]
                const index = tmpGenCols?.findIndex(col => col.value === item.value)
                tmpGenCols[index].checked = checked
                setGenInfoCols(tmpGenCols)
                addOrRemoveTableColHeaderAndVisibleReportHeader(item, checked)
            } else if (item.cat === 'child' || item.cat === 'childSupplierDetail') {
                const tmpChildGenCols = [...childInfoCols]
                const index = tmpChildGenCols?.findIndex(col => col.value === item.value)
                tmpChildGenCols[index].checked = checked
                setChildInfoCols(tmpChildGenCols)
                addOrRemoveTableColHeaderAndVisibleReportHeader(item, checked)
            } else if (item.cat === 'listSupplier' || item.cat === 'listSupplierDetails' || item.cat === 'vendorsInCalls') {
                const tmpListGenCols = [...listSupplierInfoCols]
                const index = tmpListGenCols?.findIndex(col => col.value === item.value)
                tmpListGenCols[index].checked = checked
                setListSupplierInfoCols(tmpListGenCols)
                addOrRemoveTableColHeaderAndVisibleReportHeader(item, checked)
            } else if (item.cat === 'cardAcceptance' || item.cat === 'payments' || item.cat === 'cardAcceptanceEmails') {
                const tmpCardAccCols = [...cardAccInfoCols]
                const index = tmpCardAccCols?.findIndex(col => col.value === item.value)
                tmpCardAccCols[index].checked = checked
                setCardAccInfoCols(tmpCardAccCols)
                addOrRemoveTableColHeaderAndVisibleReportHeader(item, checked)
            }
        } else {
            if (tab === 'master') {
                const tmpGenCols = [...genInfoCols]
                const index = tmpGenCols?.findIndex(col => col.value === item.value)
                tmpGenCols[index].checked = checked
                setGenInfoCols(tmpGenCols)
                addOrRemoveTableColHeaderAndVisibleReportHeader(item, checked)

            } else if (tab === 'child') {
                const tmpChildGenCols = [...childInfoCols]
                const index = tmpChildGenCols?.findIndex(col => col.value === item.value)
                tmpChildGenCols[index].checked = checked
                setChildInfoCols(tmpChildGenCols)
                addOrRemoveTableColHeaderAndVisibleReportHeader(item, checked)

            } else if (tab === 'listSupplier') {
                const tmpListGenCols = [...listSupplierInfoCols]
                const index = tmpListGenCols?.findIndex(col => col.value === item.value)
                tmpListGenCols[index].checked = checked
                setListSupplierInfoCols(tmpListGenCols)
                addOrRemoveTableColHeaderAndVisibleReportHeader(item, checked)
            } else if (tab === 'cardAcceptances') {
                const tmpCardAccCols = [...cardAccInfoCols]
                const index = tmpCardAccCols?.findIndex(col => col.value === item.value)
                tmpCardAccCols[index].checked = checked
                setCardAccInfoCols(tmpCardAccCols)
                addOrRemoveTableColHeaderAndVisibleReportHeader(item, checked)
            }
        }
    }

    const onOpenPopUp = (e) => {
        if (!primarySupplier) {
            toast.show({
                title: 'Warning',
                description: `Please Select Type Of Supplier"`
            })
            return
        }
        if (!openReportPopup) {
            setHeaderModal(true)
        } else {
            setopenReportPopup(!openReportPopup)
        }
    }

    const onChangePrimarySupplier = (value, isRun = false) => {
        if (savedReport?.id) {
            setSavedPrimarySupplier(primarySuppliers?.filter(sup => sup?.value === value))
        }
        setPrimarySupplier(primarySuppliers?.filter(sup => sup?.value === value))
        setSelectedPartnerOrCustomer([])
        setDefaultVisibleHeaders(value)

        value === "listSupplier" ? setShowPartnerList(true) : setShowPartnerList(false)
        let tmpMasterCol = []
        let tmpChildCol = []
        let tmpListSupplierCol = []
        let tmpCardAcceptanceInfoCols = []
        tmpMasterCol = tmpGeneralInfoCols.map((info) => {
            if (info.value === "suppliername" || info.value === "address1" || info.value === "address2" || info.value === "city" || info.value === "state" || info.value === "phone" || info.value === "zip") {
                info.checked = value === "masterSupplier" ? true : false
            }
            // set default columns in case of bulk update
            if (isRun && value === 'masterSupplier' && bulkUpdateMasterColumns?.includes(info.value)) {
                info.checked = value === "masterSupplier" ? true : false
            }
            return info
        })
        tmpChildCol = tmpChildGeneralInfoCols.map((info) => {
            if (info.value === "childSupplierName" || info.value === "childSupplierAddress1" || info.value === "childSupplierAddress2" || info.value === "childSupplierCity" || info.value === "childSupplierState" || info.value === "childSupplierPhone" || info.value === "childSupplierZip") {
                info.checked = value === "childSupplier" ? true : false
            }
            // set default columns in case of bulk update
            if (isRun && value === 'childSupplier' && (info.value === "childSupplierMasterId" || info.value === "childSupplierId")) {
                info.checked = value === "childSupplier" ? true : false
            }
            return info
        })
        tmpListSupplierCol = tmpListSupplierInfoCols.map((info) => {
            if (info.value === "listSupplierName" || info.value === "listSupplierAddress1" || info.value === "listSupplierAddress2" || info.value === "listSupplierCity" || info.value === "listSupplierState" || info.value === "listSupplierPhone" || info.value === "listSupplierZip") {
                info.checked = value === "listSupplier" ? true : false
            }
            return info
        })

        tmpCardAcceptanceInfoCols = tmpCardAcceptanceInfoCol.map((info) => {
            // set default columns in case of bulk update
            if (isRun && value === 'masterSupplier' && bulkUpdateMasterColumns?.includes(info.value)) {
                info.checked = value === "masterSupplier" ? true : false
            }
            return info
        })

        let allHeaders = [...tmpMasterCol, ...tmpChildCol, ...tmpListSupplierCol, ...tmpCardAcceptanceInfoCols]
        let checkedHeaders = allHeaders.filter(header => header.checked === true)
        let tableColHeader = [...checkedHeaders]
        setVisibleReportHeaders(checkedHeaders)
        setTmpVisibleReportHeaders(checkedHeaders)

        setTableColHeaders(tableColHeader)
        setTmpTableColHeaders(tableColHeader.map(info => ({ ...info })))
        setGenInfoCols(tmpMasterCol)
        setPrevGenInfoCols(tmpMasterCol.map(info => ({ ...info })))
        setChildInfoCols(tmpChildCol)
        setPrevChildInfoCols(tmpChildCol.map(info => ({ ...info })))
        setListSupplierInfoCols(tmpListSupplierCol)
        setPrevListSupplierInfoCols(tmpListSupplierCol.map(info => ({ ...info })))
        setCardAccInfoCols(tmpCardAcceptanceInfoCols)
        setPrevCardAccInfoCols(tmpCardAcceptanceInfoCols.map(info => ({ ...info })))
        setResult([])
        // run in case of bulk update
        if (isRun) {
            onRun(page, 10, 0, value, null, [], [{ filterId: 1 }], [], false, tmpMasterCol, tmpChildCol, tmpListSupplierCol, tmpCardAcceptanceInfoCols, selectedPartnerList, selectedCustomerList, checkedHeaders)
        }
    }

    const onChangePartnerOrCustomer = (selectedOption) => {
        setSelectedPartnerOrCustomer(selectedOption)
        const isPartnerFilterExist = selectedOption?.findIndex((item) => item.value === "partner")
        const isCustomerFilterExist = selectedOption?.findIndex((item) => item.value === "customer")

        if (isPartnerFilterExist === -1) {
            setSelectedPartnerList([])
        }

        if (isCustomerFilterExist === -1) {
            setSelectedCustomerList([])
        }
    }

    const onChangePartner = (selectedOption) => {
        setSelectedPartnerList(selectedOption)
    }

    const onChangeCustomer = (selectedOption) => {
        setSelectedCustomerList(selectedOption)
    }

    const onAddFilters = () => {
        if (primarySupplier === null) {
            toast.show({
                title: 'Warning',
                description: `Please Select Type Of Supplier"`
            })
            return;
        }

        if (filterList[filterList.length - 1]?.value && filterList[filterList.length - 1]?.operatorValue === undefined) {
            toast.show({
                title: 'Warning',
                description: `Please select corresponding value for "${filterList[filterList.length - 1]?.label}"`
            })
            return;
        }

        if (filterList[filterList.length - 1]?.show) {
            if ((filterList[filterList.length - 1]?.value && !filterList[filterList.length - 1]?.userInputNumber && (filterList[filterList.length - 1]?.show !== undefined || filterList[filterList.length - 1]?.show !== null)) &&
                (filterList[filterList.length - 1]?.value && !filterList[filterList.length - 1]?.userInput && (filterList[filterList.length - 1]?.show !== undefined || filterList[filterList.length - 1]?.show !== null)) &&
                (filterList[filterList.length - 1]?.value && !filterList[filterList.length - 1]?.userInputDate && (filterList[filterList.length - 1]?.show !== undefined || filterList[filterList.length - 1]?.show !== null))) {
                toast.show({
                    title: 'Warning',
                    description: `Please select corresponding value for "${filterList[filterList.length - 1]?.label}"`
                })
                return;
            }
        }

        let tmpNoOfFilters = ++noOfFilters;

        setFilterList([...filterList, { filterId: tmpNoOfFilters }])
        setNoOfFilters(tmpNoOfFilters)
    }

    const onDeleteFilter = (deletedFilterIndex) => {
        const tmpDeletedOption = filterList[deletedFilterIndex]
        const tmpFilterList = filterList.filter((filterOption, index) => index !== deletedFilterIndex)

        setFilterList(tmpFilterList)

        if (tmpDeletedOption?.value === undefined) {
            return;
        }
        delete tmpDeletedOption?.filterId
        delete tmpDeletedOption?.categoryIndex

        let updatedOption = optionsList.map((option) => {
            if (option.value === tmpDeletedOption?.value) {
                option.isDisabled = false
            }
            return option
        })

        setOptionsList(updatedOption)
    }

    const onChangeFilter = (selectedOption, categoryIndex) => {
        if (selectedOptionList.length === 0) {
            setSelectedOptionList([{ ...selectedOption, categoryIndex }])
            const tmpOptionList = optionsList.map(option => ({ ...option }))
            const index = tmpOptionList?.findIndex(col => col.value === selectedOption?.value)
            tmpOptionList[index].isDisabled = true
            // const tmpList = tmpOptionList.map((option) => {
            //     if (option.value === selectedOption?.value) {
            //         option.isDisabled = true
            //     }
            //     return option
            // })
            setOptionsList(tmpOptionList)
        } else {
            let previousCatOption = selectedOptionList.filter((option) => option.categoryIndex === categoryIndex)
            if (previousCatOption.length === 0) {
                let tmpSelectedOptionList = [...selectedOptionList]
                tmpSelectedOptionList.push({ ...selectedOption, categoryIndex })
                setSelectedOptionList(tmpSelectedOptionList)

                const tmpOptionList = optionsList.map(option => ({ ...option }))
                const index = tmpOptionList?.findIndex(option => option.value === selectedOption?.value)
                tmpOptionList[index].isDisabled = true
                setOptionsList(tmpOptionList)
            } else {
                const tmpOptions = optionsList.map(option => ({ ...option }))
                const tmpOptionList = tmpOptions.map((option) => {
                    if (option.value === selectedOption?.value) {
                        option.isDisabled = true
                    }

                    previousCatOption.forEach(prevOption => {
                        if (option?.value === prevOption?.value) {
                            option.isDisabled = false
                        }
                    })
                    return option
                })

                let tmpSelectedOptionLists = [...selectedOptionList]
                tmpSelectedOptionLists.push({ ...selectedOption, categoryIndex })
                setSelectedOptionList(tmpSelectedOptionLists)
                setOptionsList(tmpOptionList)
            }
        }

        let tmpFilterList = [...filterList]
        tmpFilterList[categoryIndex] = { filterId: categoryIndex + 1, ...selectedOption }
        tmpFilterList[categoryIndex].operatorValue = null
        setFilterList(tmpFilterList);
    }

    const onChangeOperator = (selectedOption, categoryIndex) => {
        let tmpFilterList = [...filterList]
        if (!tmpFilterList[categoryIndex]?.operatorValue) {
            tmpFilterList[categoryIndex]["operatorValue"] = selectedOption?.value
            tmpFilterList[categoryIndex]["show"] = selectedOption?.show
            tmpFilterList[categoryIndex]["currencyType"] = "$"
        } else {
            tmpFilterList[categoryIndex].operatorValue = selectedOption?.value
            tmpFilterList[categoryIndex].show = selectedOption?.show
            tmpFilterList[categoryIndex]["currencyType"] = "$"
        }
        setUserInput('')
        setFilterList(tmpFilterList);
    }

    const onUserInput = (e, categoryIndex, type = "userInput") => {
        setUserInput(e.target.value);
        let tmpFilterList = [...filterList]
        var currentFilter = tmpFilterList?.find((data => data?.filterId === categoryIndex + 1))
        if (currentFilter?.[type]) {
            currentFilter[type] = e.target.value
        } else {
            currentFilter[type] = e.target.value
        }

        tmpFilterList[categoryIndex] = currentFilter
        setFilterList(tmpFilterList)
    }

    const handleCloseExportModal = () => {
        setExportModal(false)
        setReportName('')
    }

    const onRun = async (page = 1, limitNo = 10, offsetNo = 0, primarySupplier, tmpReportId, selectedPartnerOrCustomer, filterList, resultWithoutPopUp = [], exportReport = false, genInfoCols = [], childInfoCols = [], listSupplierInfoCols = [], cardAccInfoCols = [], selectedPartnerList = [], selectedCustomerList = [], allVisibleReportHeaders = visibleReportHeaders) => {
        try {
            if (!primarySupplier && (tmpReportId === '' || tmpReportId === undefined)) {
                toast.show({
                    title: 'Warning',
                    description: 'Please Select a Type Of Supplier!'
                })
                return;
            }

            const isPartnerSelected = selectedPartnerOrCustomer.findIndex(obj => obj.value === 'partner')
            const isCustomerSelected = selectedPartnerOrCustomer.findIndex(obj => obj.value === 'customer')

            if ((isPartnerSelected !== -1 && selectedPartnerList.length === 0) || (isCustomerSelected !== -1 && selectedCustomerList.length === 0)) {
                toast.show({
                    title: 'Warning',
                    description: 'Please select corresponding partner or customer list'
                })
                return;
            }

            if (filterList[filterList.length - 1]?.value && filterList[filterList.length - 1]?.operatorValue === undefined) {
                toast.show({
                    title: 'Warning',
                    description: `Please select corresponding value "${filterList[filterList.length - 1]?.label}"`
                })
                return;
            }

            if ((filterList[filterList.length - 1]?.value && !filterList[filterList.length - 1]?.userInputNumber && filterList[filterList.length - 1]?.show) &&
                (filterList[filterList.length - 1]?.value && !filterList[filterList.length - 1]?.userInput && filterList[filterList.length - 1]?.show) &&
                (filterList[filterList.length - 1]?.value && !filterList[filterList.length - 1]?.userInputDate && filterList[filterList.length - 1]?.show)) {
                toast.show({
                    title: 'Warning',
                    description: `Please select corresponding value for "${filterList[filterList.length - 1]?.label}"`
                })
                return;
            }

            setPage(page)
            setLoader(true)
            let finalFilterList = []
            let tmpPartnerList = []
            let tmpCustomerList = []

            tmpPartnerList = selectedPartnerList?.map((partner) => {
                return { ...partner, cat: "partner" }
            })

            tmpCustomerList = selectedCustomerList?.map((customer) => {
                return { ...customer, cat: "customer" }
            })

            setPartnerList(tmpPartnerList)
            setCustomerList(tmpCustomerList)

            finalFilterList = [...filterList]
            setFinalFilter(finalFilterList)

            const IsAccFilterApplied = finalFilterList.findIndex(col => col.cat === "cardAcceptances")
            const IsPaymentFilterApplied = finalFilterList.findIndex(col => col.cat === "payments")
            const IsSupplierDetailsFilterApplied = finalFilterList.findIndex(col => col.cat === "supplierDetails" && col.mainCategory === 'child')
            const isMasterSupplierDetailsFilterApplied = finalFilterList.findIndex(col => col.cat === "supplierDetails" && col.mainCategory === 'master')
            const isListSupplierDetailsFilterApplied = finalFilterList.findIndex(col => col.cat === "listSupplierDetails" && col.mainCategory === 'listSupplier')
            const isAccEmailFilterApplied = finalFilterList.findIndex(col => col.cat === "cardAcceptanceEmails" && col.mainCategory === 'listSupplier')
            const isCcRemitFilterApplied = finalFilterList.findIndex(col => col.value === "creditCardRemittanceEmail")
            const isCcPayFilterApplied = finalFilterList.findIndex(col => col.value === "creditCardPaymentEmail")
            const isLastCalledDateFilter = finalFilterList.findIndex(col => col.cat === "vendorsInCalls")

            let isAcceptanceFilterApplied = IsAccFilterApplied === -1 ? false : true
            let isSupDetailsFilterApplied = IsSupplierDetailsFilterApplied === -1 ? false : true
            let IsPayFilterApplied = IsPaymentFilterApplied === -1 ? false : true
            let isMasterSupDetailsFilterApplied = isMasterSupplierDetailsFilterApplied === -1 ? false : true
            let isListSupDetailsFilterApplied = isListSupplierDetailsFilterApplied === -1 ? false : true
            let isAcceptanceEmailFilterApplied = isAccEmailFilterApplied === -1 ? false : true
            let isCcRemittanceFilterApplied = isCcRemitFilterApplied === -1 ? false : true
            let isCcPaymentFilterApplied = isCcPayFilterApplied === -1 ? false : true
            const isLastCalledDateFilterApplied = isLastCalledDateFilter === -1 ? false : true

            const isChildColChecked = childInfoCols.findIndex(col => col.checked === true && (col.cat === 'child' || col.cat === 'childSupplierDetail') && col.mainCategory === 'child')
            const isCardAcceptanceChecked = cardAccInfoCols.findIndex(col => col.checked === true && col.cat === "cardAcceptance")
            const isMasterColChecked = genInfoCols.findIndex(col => col.checked === true)
            const isChildSupplierDetailColChecked = childInfoCols.findIndex(col => col.checked === true && col.cat === "childSupplierDetail" && col.mainCategory === 'child')
            const isPaymentColChecked = cardAccInfoCols.findIndex(col => col.checked === true && col.cat === "payments")
            const isMasterSupplierDetailsColChecked = genInfoCols.findIndex(col => col.checked === true && col.cat === "supplierDetails" && col.mainCategory === 'master')
            const isChildColForMasterChecked = childInfoCols.findIndex(col => col.checked === true && col.cat === "child" && col.mainCategory === 'child')
            const isListSupplierDetailsColChecked = listSupplierInfoCols.findIndex(col => col.checked === true && col.cat === "listSupplierDetails" && col.mainCategory === 'listSupplier')
            const isAccEmailsColChecked = cardAccInfoCols.findIndex(col => col.checked === true && col.cat === "cardAcceptanceEmails")
            const isCcRemitColChecked = cardAccInfoCols.findIndex(col => col.checked === true && col.cat === "cardAcceptanceEmails" && col.value === "creditCardRemittanceEmail")
            const isCcPayColChecked = cardAccInfoCols.findIndex(col => col.checked === true && col.cat === "cardAcceptanceEmails" && col.value === "creditCardPaymentEmail")
            const isUserIdInMasterColChecked = genInfoCols.findIndex(col => col.value === 'userId' && col.checked === true)
            const isUserIdInChildColChecked = genInfoCols.findIndex(col => col.value === 'userId' && col.checked === true)
            const isLastCalledDateCol = listSupplierInfoCols.findIndex(col => col.checked === true && col.cat === 'vendorsInCalls' && col.mainCategory === 'listSupplier')
            const isParentOrganizationsCol = genInfoCols.findIndex(col => col.checked === true && col.cat === 'parentOrganization')

            let isChildHeaderSelected = isChildColChecked === -1 ? false : true
            let isCardAcceptanceHeaderSelected = isCardAcceptanceChecked === -1 ? false : true
            let isMasterHeaderSelected = isMasterColChecked === -1 ? false : true
            let isChildSupDetailColChecked = isChildSupplierDetailColChecked === -1 ? false : true
            let isPayColChecked = isPaymentColChecked === -1 ? false : true
            let isMasterSupDetailsColChecked = isMasterSupplierDetailsColChecked === -1 ? false : true
            let isChildColCheckedForMaster = isChildColForMasterChecked === -1 ? false : true
            let isListSupDetailsColChecked = isListSupplierDetailsColChecked === -1 ? false : true
            let isAcceptanceEmailColChecked = isAccEmailsColChecked === -1 ? false : true
            let isCcRemittanceColChecked = isCcRemitColChecked === -1 ? false : true
            let isCcPaymentColChecked = isCcPayColChecked === -1 ? false : true
            let isUserIdMasterColChecked = isUserIdInMasterColChecked === -1 ? false : true
            let isUserIdChildColChecked = isUserIdInChildColChecked === -1 ? false : true
            let isLastCalledDateColChecked = isLastCalledDateCol === -1 ? false : true
            let isParentOrganizationsChecked = isParentOrganizationsCol === -1 ? false : true

            let isGetCardAcc = false
            let isGetPayment = false

            if (isCardAcceptanceHeaderSelected || isAcceptanceFilterApplied) {
                isGetCardAcc = true
            }

            if (isPaymentColChecked || IsPayFilterApplied) {
                isGetPayment = true
            }

            let responseData = []
            let contacts = []
            let totalData = 0

            let headers = resultWithoutPopUp?.length !== 0 ? [...resultWithoutPopUp] : [...allVisibleReportHeaders]
            let reportHeaders = headers.filter(header => header.value !== 'popUp')

            if (primarySupplier === "listSupplier") {
                await dispatch(createListSupplierReport(
                    finalFilterList,
                    limitNo,
                    offsetNo,
                    primarySupplier,
                    isMasterHeaderSelected,
                    isChildHeaderSelected,
                    isCardAcceptanceHeaderSelected,
                    isAcceptanceFilterApplied,
                    isSupDetailsFilterApplied,
                    isChildSupDetailColChecked,
                    isPayColChecked,
                    IsPayFilterApplied,
                    isMasterSupDetailsFilterApplied,
                    isMasterSupDetailsColChecked,
                    isChildColCheckedForMaster,
                    isListSupDetailsFilterApplied,
                    isListSupDetailsColChecked,
                    isAcceptanceEmailFilterApplied,
                    isAcceptanceEmailColChecked,
                    isCcRemittanceFilterApplied,
                    isCcPaymentFilterApplied,
                    isCcRemittanceColChecked,
                    isCcPaymentColChecked,
                    reportHeaders,
                    tmpPartnerList,
                    tmpCustomerList,
                    isLastCalledDateFilterApplied,
                    isLastCalledDateColChecked
                )).then(async (response) => {
                    contacts = await getAllContacts(response?.data)
                    setLoader(false)
                    responseData = updateReportFeesColumn(response, isCardAcceptanceHeaderSelected, isAcceptanceFilterApplied, isCcRemittanceFilterApplied, isCcPaymentFilterApplied, isCcRemittanceColChecked, isCcPaymentColChecked, IsPayFilterApplied, isPayColChecked)
                    totalData = response?.totalRecords[0]?.count
                })
            } else if (primarySupplier === "masterSupplier") {
                let masterSupplierHeader = reportHeaders.find(header => header.value === "masterSupplierId");
                if (!masterSupplierHeader) {
                    let supplierIdData = {
                        cat: "master",
                        checked: false,
                        label: "Master Supplier Id",
                        mainCategory: "master",
                        selectQuery: "\"supTable\".\"id\" as \"masterSupplierId\"",
                        value: "masterSupplierId",
                    };
                    reportHeaders.push(supplierIdData);
                }
                await dispatch(createMasterSupplierReport(
                    finalFilterList,
                    limitNo,
                    offsetNo,
                    primarySupplier,
                    isMasterHeaderSelected,
                    isChildHeaderSelected,
                    isCardAcceptanceHeaderSelected,
                    isAcceptanceFilterApplied,
                    isSupDetailsFilterApplied,
                    isChildSupDetailColChecked,
                    isPayColChecked,
                    IsPayFilterApplied,
                    isMasterSupDetailsFilterApplied,
                    isMasterSupDetailsColChecked,
                    isChildColCheckedForMaster,
                    isAcceptanceEmailFilterApplied,
                    isAcceptanceEmailColChecked,
                    isCcRemittanceFilterApplied,
                    isCcPaymentFilterApplied,
                    isCcRemittanceColChecked,
                    isCcPaymentColChecked,
                    reportHeaders,
                    isUserIdMasterColChecked,
                    tmpPartnerList,
                    tmpCustomerList,
                    isParentOrganizationsChecked
                )).then(async (response) => {
                    contacts = await getAllContacts(response?.data)
                    setLoader(false)
                    responseData = updateReportFeesColumn(response, isCardAcceptanceHeaderSelected, isAcceptanceFilterApplied, isCcRemittanceFilterApplied, isCcPaymentFilterApplied, isCcRemittanceColChecked, isCcPaymentColChecked, IsPayFilterApplied, isPayColChecked)
                    totalData = response?.totalRecords[0]?.count
                })
            } else {
                let childSupplierHeader = reportHeaders.find(header => header.value === "childSupplierId");
                if (!childSupplierHeader) {
                    let childSupplierIdData = {
                        cat: "child",
                        checked: false,
                        label: "Child Supplier Id",
                        mainCategory: "child",
                        selectQuery: "\"childSupplierTable\".\"id\" as \"childSupplierId\"",
                        value: "childSupplierId",
                    }
                    reportHeaders.push(childSupplierIdData);
                }

                await dispatch(createChildSupplierReport(
                    finalFilterList,
                    limitNo,
                    offsetNo,
                    primarySupplier,
                    isMasterHeaderSelected,
                    isChildHeaderSelected,
                    isCardAcceptanceHeaderSelected,
                    isAcceptanceFilterApplied,
                    isSupDetailsFilterApplied,
                    isChildSupDetailColChecked,
                    isPayColChecked,
                    IsPayFilterApplied,
                    isMasterSupDetailsFilterApplied,
                    isMasterSupDetailsColChecked,
                    isChildColCheckedForMaster,
                    isAcceptanceEmailFilterApplied,
                    isAcceptanceEmailColChecked,
                    isCcRemittanceFilterApplied,
                    isCcPaymentFilterApplied,
                    isCcRemittanceColChecked,
                    isCcPaymentColChecked,
                    reportHeaders,
                    isUserIdChildColChecked,
                )).then(async (response) => {
                    contacts = await getAllContacts(response?.data)
                    setLoader(false)
                    responseData = updateReportFeesColumn(response, isCardAcceptanceHeaderSelected, isAcceptanceFilterApplied, isCcRemittanceFilterApplied, isCcPaymentFilterApplied, isCcRemittanceColChecked, isCcPaymentColChecked, IsPayFilterApplied, isPayColChecked)
                    totalData = response?.totalRecords[0]?.count
                })
            }
            if (exportReport) {
                let result = convertToArrayOfArrays(responseData, contacts);
                if (bulkUpdateSupplier) {
                    setReportName('bulkupdate-' + bulkUpdateSupplier)
                }
                setExportData(result)
            } else {
                setReportName(primarySupplier + '-report')
                setResult(responseData)
                setReportContacts(contacts || [])
                setTotalRecords(totalData)
            }

        } catch (err) {
            toast.show({
                title: 'Warning',
                description: 'Error while adding filters'
            })
            setLoader(false)
            setResult([])
            setReportContacts([])
            setTotalRecords(0)
        }
    }

    const convertToArrayOfArrays = (data, contacts = reportContacts) => {
        let tempHeaderValue = []
        if (data.length === 0) return [];
        let headers = Object.keys(data[0]);
        const phoneColumns = ['phone', 'childSupplierPhone', 'listSupplierPhone', 'cardPaymentByPhoneValue', 'cardPaymentIVRPhone']
        const emailColumns = ['email', 'childSupplierEmail', 'listSupplierEmail', 'mastersPaymentEmailAch', 'creditCardPaymentEmail', 'creditCardRemittanceEmail', 'mastersCardAccEmail']
        if (bulkUpdateSupplier) {
            if (bulkUpdateSupplier === 'master') {
                headers = headers.filter(header => bulkUpdateMasterColumns?.includes(header))
                headers.map(header => {
                    tempHeaderValue.push(bulkUpdateMasterColumnsValues?.[header]?.headerValue)
                })
            }
            if (bulkUpdateSupplier === 'child') {
                headers = headers.filter(header => bulkUpdateChildColumns?.includes(header))
                headers.map(header => {
                    tempHeaderValue.push(bulkUpdateChildColumnsValues?.[header]?.headerValue)
                })
            }
        }
        const values = data.map(obj =>
            headers.map(header => {
                if (header?.toLowerCase() === 'childqastatus' || header?.toLowerCase() === 'masterqastatus') {
                    obj[header] = obj[header] === 8 ? 'Approved' : obj[header] === 7 ? 'Rejected' : (obj[header] === 6 || obj[header] === null || !obj[header]) ? 'Pending' : "In Calls"
                    return obj[header] ? `"${obj[header]?.toString()?.trim()?.replace(/(?:\\[rn]|[\r\n])/g, " ")}"` : ''
                } else if (phoneColumns?.includes(header)) {
                    const tmpValue = obj?.[header] || ''
                    const value = tmpValue && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpValue) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(tmpValue) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(tmpValue) && /^\d+$/.test(tmpValue)) && /^\d+$/.test(tmpValue) ? contacts?.find(data => data?.id === parseInt(tmpValue))?.phone : (tmpValue || '')
                    return value ? `"${value?.toString()?.trim()?.replace(/(?:\\[rn]|[\r\n])/g, " ")}"` : ''
                } else if (emailColumns?.includes(header)) {
                    const tmpValue = obj?.[header] || ''
                    const value = tmpValue && /^\d+$/.test(tmpValue) && /^\d+$/.test(tmpValue) ? contacts?.find(data => data?.id === parseInt(tmpValue))?.email : (tmpValue || '')
                    return value ? `"${value?.toString()?.trim()?.replace(/(?:\\[rn]|[\r\n])/g, " ")}"` : ''
                } else {
                    return obj[header] ? `"${obj[header]?.toString()?.trim()?.replace(/(?:\\[rn]|[\r\n])/g, " ")}"` : '' //.replaceAll('#', '')//.replaceAll(',', '')
                }
            })
        );
        if (bulkUpdateSupplier) {
            const result = [];
            values.forEach((item) => {
                const existingItem = result.find((el) => el[0] === item[0]);
                if (existingItem) {
                    if (item[48] && !existingItem[48].includes(item[48])) {
                        existingItem[48] = existingItem[48]
                            ? `"${existingItem[48].replace(/"/g, '')}, ${item[48].replace(/"/g, '')}"`
                            : `"${item[48].replace(/"/g, '')}"`;
                    }

                    if (item[49] && !existingItem[49].includes(item[49])) {
                        existingItem[49] = existingItem[49]
                            ? `"${existingItem[49].replace(/"/g, '')}, ${item[49].replace(/"/g, '')}"`
                            : `"${item[49].replace(/"/g, '')}"`;
                    }
                } else {
                    result.push([...item]);
                }
            });
            return [headers, tempHeaderValue, ...result];
        } else {
            return [headers, ...values];
        }
    };


    const onUpdateHeader = () => {
        let updatedHeader = visibleReportHeaders.map(header => {
            header['key'] = header.value
            if (header.value === 'popUp') {
                return
            }
            return header
        })
        let updatedHeaders = updatedHeader.filter(header => header !== undefined)
        setHeaderExport(updatedHeaders)
    }

    const onExport = async (done) => {
        await onRun(page, null, null, primarySupplier[0]?.value, null, selectedPartnerOrCustomer, filterList, [], true, genInfoCols, childInfoCols, listSupplierInfoCols, cardAccInfoCols, selectedPartnerList, selectedCustomerList)
        onUpdateHeader()
        setExportModal(true)
    }

    const newReportHandler = () => {
        history.push('/reports');
        setOptionsList([])
        setReportName('')
        setSavedReport({})
        setSavedReportId(null)
        setFilterList([{ filterId: 1 }])
        setVisibleReportHeaders([])
        setResult([])
        setPrimarySupplier(null)
        setSavedPartnerOrPartner([])
        setShowPartnerList(false)
        setSelectedPartnerOrCustomer([])
        setSelectedPartnerList([])
        setSelectedCustomerList([])
        setExportData([])
        setActive("generalInfo")
        setTableColHeaders(tableColumnHeaders)
        setGenInfoCols(generalInfoCols)
        setChildInfoCols(childGeneralInfoCols)
        setCardAccInfoCols(cardAcceptanceInfoCol)
        setListSupplierInfoCols(listSupInfoCols)
        setBulkUpdateSupplier('')
    }

    const setDefaultVisibleHeaders = (primarySupplier) => {
        if (primarySupplier === "masterSupplier") {
            let tmpChildCols = childGeneralInfoCols?.map(info => {
                if (info?.checked) {
                    info.checked = !info?.checked
                }
                return info
            })
            let tmpListCols = listSupInfoCols?.map(info => {
                if (info?.checked) {
                    info.checked = !info?.checked
                }
                return info
            })
            let tmpCardAcceptanceCols = cardAcceptanceInfoCol?.map(info => {
                if (info?.checked) {
                    info.checked = !info?.checked
                }
                return info
            })
            setChildInfoCols(tmpChildCols)
            setListSupplierInfoCols(tmpListCols)
            setCardAccInfoCols(tmpCardAcceptanceCols)
        } else if (primarySupplier === "childSupplier") {
            const tmpCols = [...generalInfoCols]
            let tmpMasterCols = tmpCols?.map(info => {
                if (info?.checked) {
                    info.checked = !info?.checked
                }
                return info
            })
            let tmpListCols = listSupInfoCols?.map(info => {
                if (info?.checked) {
                    info.checked = !info?.checked
                }
                return info
            })
            let tmpCardAcceptanceCols = cardAcceptanceInfoCol?.map(info => {
                if (info?.checked) {
                    info.checked = !info?.checked
                }
                return info
            })

            setGenInfoCols(tmpMasterCols)
            setListSupplierInfoCols(tmpListCols)
            setCardAccInfoCols(tmpCardAcceptanceCols)
        } else if (primarySupplier === "listSupplier") {
            const tmpCols = [...generalInfoCols]
            let tmpMasterCols = tmpCols?.map(info => {
                if (info?.checked) {
                    info.checked = !info?.checked
                }
                return info
            })

            let tmpChildCols = childGeneralInfoCols?.map(info => {
                if (info?.checked) {
                    info.checked = !info?.checked
                }
                return info
            })

            let tmpCardAcceptanceCols = cardAcceptanceInfoCol?.map(info => {
                if (info?.checked) {
                    info.checked = !info?.checked
                }
                return info
            })
            setGenInfoCols(tmpMasterCols)
            setChildInfoCols(tmpChildCols)
            setCardAccInfoCols(tmpCardAcceptanceCols)
        }
    }

    useEffect(() => {
        dispatch(getAllPartners())
            .then((partners) => {
                const partnerList = partners.map((partner) => {
                    return { value: partner.id, label: partner.partnerName }
                })
                setPartners(partnerList)
            })
            .catch((err) => {
                setPartners([])
            })

        dispatch(getCustomerNames())
            .then((customers) => {
                const customerList = customers.map((customer) => {
                    return {
                        label: customer.companyName,
                        value: customer.companyName
                    }
                })
                setCustomers(customerList)
            })
            .catch((err) => {
                setCustomers([])
            })
    }, [])

    const onPageChange = async (e) => {
        const newOffset = (e - 1) * limit;
        await onRun(e, limit, newOffset, primarySupplier[0]?.value, tmpReportId, selectedPartnerOrCustomer, filterList, [], false, genInfoCols, childInfoCols, listSupplierInfoCols, cardAccInfoCols, selectedPartnerList, selectedCustomerList)
        setLoader(false)
    }

    const headerElements = (columns) => {
        return columns?.map((col, index) => {
            if (col.name === "suppliername") {
                return (
                    <Column
                        resizable
                        // sortable
                        key={col.value}
                        minWidth={50}
                    >
                        <HeaderCell className='fw-bold text-black' title="Supplier Name">Supplier Name</HeaderCell>
                        <CustomCell dataKey={col.value} col={col} />
                    </Column>
                )
            } else if (col.name === "creditCardCondition") {
                return (
                    <Column
                        resizable
                        // sortable
                        key={col.value}
                        minWidth={50}
                    >
                        <HeaderCell className='fw-bold text-black' title={col.label}>{col.label}</HeaderCell>
                        <CustomCell dataKey={col.value} col={col} />
                    </Column>
                )
            } else if (col.name === "userId") {
                return (
                    <Column
                        resizable
                        // sortable
                        key={col.value}
                        minWidth={50}
                    >
                        <HeaderCell className='fw-bold text-black' title='Added By User'>Added By User</HeaderCell>
                        <CustomCell dataKey={col.value} col={col} />
                    </Column>
                )
            } else if (col.name === "cashPaymentDiscount") {
                return (
                    <Column
                        resizable
                        // sortable
                        key={col.value}
                        minWidth={50}
                    >
                        <HeaderCell className='fw-bold text-black' title={col.label}>{col.label} </HeaderCell>
                        <CustomCell dataKey={col.value} col={col} />
                    </Column>
                )
            } else if (col.name === "approvedByQA") {
                return (
                    <Column
                        resizable
                        // sortable
                        key={col.value}
                        minWidth={50}
                    >
                        <HeaderCell className='fw-bold text-black' title={col.label}>{col.label}</HeaderCell>
                        <CustomCell dataKey={col.value} col={col} />
                    </Column>
                )
            } else {
                return (
                    <Column
                        resizable
                        // sortable
                        key={col.value}
                        minWidth={50}
                    >
                        <HeaderCell className='fw-bold text-black' title={col.label}>{col.label}</HeaderCell>
                        <CustomCell dataKey={col.value} col={col} contacts={reportContacts} primarySupplier={primarySupplier} />
                    </Column>
                )
            }
        })
    }

    const onSave = () => {
        setReportName(primarySupplier?.[0]?.value + '-report')
        setShowDialog(true)
    }

    const onSaveReport = () => {
        dispatch(saveReport(finalFilter, reportName, visibleReportHeaders, primarySupplier[0]?.value, partnerList, customerList)).then((res) => {
            setSavedReportId(res?.data?.id)
            toast.show({
                title: 'Success',
                description: 'Saved The Report Successfully'
            })
            setShowDialog(false)
            getSavedReportsData()
        }).catch((err) => {
            toast.show({
                title: 'Warning',
                description: 'Unable to save the report'
            })
            setShowDialog(false)
        })
    }

    const handleClose = () => {
        setShowDialog(false)
        setReportName('')
    }

    const onChangeActiveGeneralInfo = (tab) => {
        setSubGeneralBtnActive(tab)
    }

    const onShareHandler = (notes) => {
        let editorContent = draftToHtml(convertToRaw(notes.getCurrentContent()));
        let regex = /<a .*?>/g
        const emailsArray = [...editorContent.matchAll(regex)]
        let emails = []
        emailsArray && emailsArray.map((item) => {
            let hrefRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g
            let valueRegex = /<a\s+(?:[^>]*?\s+)?data-value="([^"]*)"/g
            const hrefArray = [...item[0].matchAll(hrefRegex)]
            const valueArray = [...item[0].matchAll(valueRegex)]

            if (hrefArray.length && valueArray.length) {
                const href = hrefArray?.[0]?.[1]
                const value = valueArray?.[0]?.[1]
                let email = href.replaceAll('https://', '')
                let id = email.split('/')[1]

                emails.push({ email: email.split('/')[0], name: value.replaceAll('https://', ''), id, reportName, reportId: savedReportId })
            }
        })

        dispatch(shareReport(emails)).then((res) => {
            toast.show({
                title: 'Success',
                description: 'Share The Report Successfully'
            })
        }).catch(err => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Share The Report'
            })
        })
    }

    const onCurrencyChange = (e, categoryIndex) => {
        setUserInput(e.value);
        let tmpFilterList = [...filterList]
        var currentFilter = tmpFilterList?.find((data => data?.filterId === categoryIndex + 1))

        if (currentFilter?.userInputNumber) {
            currentFilter["currencyType"] = e.value
        } else {
            currentFilter.currencyType = e.value
        }
        tmpFilterList[categoryIndex] = currentFilter
        setFilterList(tmpFilterList)
    }

    const currencyOptions = [
        {
            label: '$',
            value: '$',
        },
        {
            label: '%',
            value: '%',
        },
    ]

    const onCloseSavedReportModal = () => {
        setSavedReportsModal(false)
    }

    const onSelectSavedReports = (name) => {
        setSelectedReportTab(name)
        if (name === 'saved') {
            setMyReportsSelected(true)
            setSharedReportSelected(false)
        } else {
            setMyReportsSelected(false)
            setSharedReportSelected(true)
        }
    }

    const getSavedReportsData = useCallback(async (limit, offset) => {
        await dispatch(getSavedReports(limit, offset)).then(res => {
            setAllReports(res?.allReports)
        }).catch(err => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Get Saved Reports'
            })
        })


        await dispatch(getMySharedReports()).then(res => {
            let results = res?.map(report => {
                let reportObj = { title: report?.report?.title, id: report?.reportId }
                return reportObj
            })
            setSharedToMe(results)
        }).catch(err => {
            toast.show({
                title: 'Warning',
                description: 'Unable To Get Shared Reports'
            })
        })
    }, [])

    const getAllContacts = async (reportData = []) => {
        let contacts = []
        const phones = reportData?.map(data => data?.phone && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.phone) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.phone) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.phone) && /^\d+$/.test(data?.phone)) ? data?.phone : null)
        const emails = reportData?.map(data => data?.email && /^\d+$/.test(data?.email) ? data?.email : null)
        const childSupplierPhones = reportData?.map(data => data?.childSupplierPhone && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.childSupplierPhone) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.childSupplierPhone) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.childSupplierPhone) && /^\d+$/.test(data?.childSupplierPhone)) ? data?.childSupplierPhone : null)
        const childSupplierEmails = reportData?.map(data => data?.childSupplierEmail && /^\d+$/.test(data?.childSupplierEmail) ? data?.childSupplierEmail : null)
        const listSupplierPhones = reportData?.map(data => data?.listSupplierPhone && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.listSupplierPhone) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.listSupplierPhone) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.listSupplierPhone) && /^\d+$/.test(data?.listSupplierPhone)) ? data?.listSupplierPhone : null)
        const listSupplierEmails = reportData?.map(data => data?.listSupplierEmail && /^\d+$/.test(data?.listSupplierEmail) ? data?.listSupplierEmail : null)
        const cardPaymentByPhoneValues = reportData?.map(data => data?.cardPaymentByPhoneValue && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentByPhoneValue) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.cardPaymentByPhoneValue) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.cardPaymentByPhoneValue) && /^\d+$/.test(data?.cardPaymentByPhoneValue)) ? data?.cardPaymentByPhoneValue : null)
        const cardPaymentIVRPhones = reportData?.map(data => data?.cardPaymentIVRPhone && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentIVRPhone) && !/(?:\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.cardPaymentIVRPhone) && !/(?:\(\d{3}\)-\d{3}-\d{4}|\(\d{3}\)\s?\d{3}-\d{4}|1\s\d{3}-\d{3}-\d{4}|1\s?\(\d{3}\)\s?\d{3}-\d{4})/i.test(data?.cardPaymentIVRPhone) && /^\d+$/.test(data?.cardPaymentIVRPhone)) ? data?.cardPaymentIVRPhone : null)
        const mastersPaymentEmailAchs = reportData?.map(data => data?.mastersPaymentEmailAch && /^\d+$/.test(data?.mastersPaymentEmailAch) ? data?.mastersPaymentEmailAch : null)
        const creditCardPaymentEmails = reportData?.map(data => data?.creditCardPaymentEmail && /^\d+$/.test(data?.creditCardPaymentEmail) ? data?.creditCardPaymentEmail : null)
        const creditCardRemittanceEmails = reportData?.map(data => data?.creditCardRemittanceEmail && /^\d+$/.test(data?.creditCardRemittanceEmail) ? data?.creditCardRemittanceEmail : null)

        let contactIds = []
        let allContactIds = contactIds.concat(phones, emails, childSupplierPhones, childSupplierEmails, listSupplierPhones, listSupplierEmails, cardPaymentByPhoneValues, cardPaymentIVRPhones, mastersPaymentEmailAchs, creditCardPaymentEmails, creditCardRemittanceEmails);
        contactIds = allContactIds?.filter(data => data && /^\d+$/.test(data))
        const uniqueContactIds = [...new Set(contactIds)]
        if (uniqueContactIds && uniqueContactIds?.length > 0) {
            contacts = await getAllContactsByIds(uniqueContactIds, dispatch)
        }
        return contacts
    }

    const handleBulkUpdateMaster = () => {
        history.push('/reports');
        onChangePrimarySupplier('masterSupplier', true)
        setBulkUpdateSupplier('master')
        setSavedReportsModal(false)
    }

    const handleBulkUpdateChild = () => {
        history.push('/reports');
        onChangePrimarySupplier('childSupplier', true)
        setBulkUpdateSupplier('child')
        setSavedReportsModal(false)
    }

    return (
        <div className="padding-left bg-white ">
            <div className="  ml-3 pl-3" >
                <h1 className="report_heading">Report</h1>
                {showShareModal && <QaNotesModal
                    show={showShareModal}
                    onClose={() => setShowShareModal(false)}
                    onDone={onShareHandler}
                    page='report'
                />}
                <ModalComponent
                    backdrop={backdrop}
                    open={savedReportsModal}
                    handleClose={onCloseSavedReportModal}
                    modalTitle={`Saved Reports`}
                    size={`md`}>

                    <div className="container" style={{ height: 400 }}>
                        <div className="row h-100" >
                            <div className="col-3 p-0">
                                <div role="button" className="d-flex justify-content-between align-items-center mt-4 mb-4" onClick={() => { onSelectSavedReports('shared') }}>
                                    <h4 className="mb-0" > Shared With Me </h4>
                                    <IoIosArrowForward color="#65B3E9" size={14} />
                                </div>
                                <div role="button" className="d-flex justify-content-between align-items-center mt-4 mb-4" onClick={() => { onSelectSavedReports('saved') }}>
                                    <h4 className="mb-0"> My Reports </h4>
                                    <IoIosArrowForward color="#65B3E9" size={14} />
                                </div>
                                {(isAdmin || user?.isBulkUpdate) && (
                                    <div role="button" className="d-flex justify-content-between align-items-center mt-4 mb-4" onClick={() => { onSelectSavedReports('richochet') }}>
                                        <h4 className="mb-0"> Ricochet Reports </h4>
                                        <IoIosArrowForward color="#65B3E9" size={14} />
                                    </div>
                                )}
                            </div>
                            <div className="col-7 h-100" >
                                <div className="border h-75" style={{ marginTop: sharedReportSelected ? '' : 40 }}>
                                    {selectedReportTab === 'saved' ? (<div style={{ height: '100%', overflowY: 'scroll' }} className="no-scrollbar " >
                                        <div className="p-3">
                                            {allReports.map(report => <Link key={report?.name} className="report_Links" to={{ pathname: `/report/${report?.id}` }} onClick={() => { setSavedReportsModal(false) }}><div> <FaRegFileLines color="#104569" style={{ marginRight: '3px' }} /> {report?.title} </div> </Link>)}
                                        </div>
                                    </div>) : selectedReportTab === 'shared' ? (<div className="p-3">
                                        {sharedToMe.map(report => <Link className="report_Links" to={{ pathname: `/report/${report?.id}` }} onClick={() => { setSavedReportsModal(false) }}><div> <FaRegFileLines color="#104569" style={{ marginRight: '3px' }} /> {report?.title} </div> </Link>)}
                                    </div>) : (selectedReportTab === 'richochet' && (isAdmin || user?.isBulkUpdate)) ? (
                                        <div className="p-3">
                                            <div role="button" className="report_Links" onClick={() => { handleBulkUpdateMaster() }}><div> <FaRegFileLines color="#104569" style={{ marginRight: '3px' }} />  Bulk Update - Master </div> </div>
                                            <div role="button" className="report_Links" onClick={() => { handleBulkUpdateChild() }}><div> <FaRegFileLines color="#104569" style={{ marginRight: '3px' }} /> Bulk Update - Child </div> </div>
                                        </div>
                                    ) : <></>}
                                </div>
                            </div>
                        </div>

                    </div>
                </ModalComponent>
                <div className={`d-flex mt-3 justify-content-${savedReport?.id ? 'between' : 'end'}`}>
                    {savedReport?.id && <h2 className="d-flex align-items-center">{savedReport?.title.toUpperCase()}</h2>}
                    <div className="d-flex column-gap-2 mb-3 ">
                        <button className="report_heading_buttons report_button_success" style={{ fontSize: 14 }} onClick={() => { setSavedReportsModal(true) }}> Saved  Reports</button>
                        <button className="report_heading_buttons report_button_secondary" style={{ fontSize: 14 }} onClick={newReportHandler} disabled={loader}> New Reports</button>
                        <button className="report_heading_buttons report_button_secondary " style={{ fontSize: 14 }} onClick={onShare} disabled={!savedReportId || loader}> <FaRegShareFromSquare /> Share</button>
                    </div>
                </div>
                <div id="report-parent">
                    <div className="" style={{ overflowY: "auto", height: 'auto', overflowX: 'hidden' }}>
                        <div className="w-100 d-flex column-gap-1 pt-4 pb-4 border" style={{ height: "23%" }}>
                            <div className="ms-5 me-5">
                                <button onClick=''><RiDeleteBin5Line size={30} display={'none'} /></button>
                            </div>
                            <div className="col-3 ">
                                <Select
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: 'grey'
                                        }),
                                    }}
                                    classNamePrefix='react-select-selector'
                                    className=" w-75"
                                    menuPortalTarget={document.getElementById("report-parent")}
                                    menuPosition={'fixed'}
                                    options={primarySuppliers || []}
                                    onChange={(e) => { onChangePrimarySupplier(e.value, 0) }}
                                    value={(savedReport?.id && !savedPrimarySupplier) ? null : savedReport?.id ? {
                                        label: savedPrimarySupplier[0]?.label,
                                        value: savedPrimarySupplier[0]?.value
                                    } : !primarySupplier ? null : {
                                        label: primarySupplier[0]?.label,
                                        value: primarySupplier[0]?.value
                                    }}
                                    isDisabled={bulkUpdateSupplier ? true : false}
                                />
                            </div>
                            {showPartnerList && <div className="col-3">
                                <Select
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: 'grey'
                                        }),
                                    }}
                                    classNamePrefix='react-select-selector'
                                    className="w-75"
                                    menuPortalTarget={document.getElementById("report-parent")}
                                    menuPosition={'fixed'}
                                    options={customerOrPartner || []}
                                    onChange={(e) => { onChangePartnerOrCustomer(e) }}
                                    isMulti
                                    value={savedReport?.id ? savedPartnerOrCustomer : selectedPartnerOrCustomer}
                                />
                            </div>}

                            {selectedPartnerOrCustomer?.map((optionSelected) => {
                                if (optionSelected?.value === "partner") {
                                    return (<div className=" col-3">
                                        <Select
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    borderColor: 'grey'
                                                }),
                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                            }}
                                            classNamePrefix='react-select-selector'
                                            className="w-75"
                                            menuPortalTarget={document.getElementById("report-parent")}
                                            menuPosition={'fixed'}
                                            options={partners.length === 0 ? [] : partners}
                                            onChange={(e) => { onChangePartner(e) }}
                                            isMulti
                                            value={selectedPartnerList}
                                        />
                                    </div>)
                                } else if (optionSelected?.value === "customer") {
                                    return (
                                        <div className=" col-3">
                                            <Select
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: 'grey'
                                                    }),
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                                classNamePrefix='react-select-selector'
                                                className="w-75"
                                                menuPortalTarget={document.getElementById("report-parent")}
                                                menuPosition={'fixed'}
                                                options={customers.length === 0 ? [] : customers}
                                                onChange={(e) => { onChangeCustomer(e) }}
                                                isMulti
                                                value={selectedCustomerList}
                                            />
                                        </div>
                                    )
                                }
                            })}
                        </div>
                        {filterList.length > 1 ? <div className="w-100 border pt-4 pb-4 mt-4">
                            {filterList?.map((category, index) => {
                                if (index === 0) {
                                    return null;
                                }
                                let options = category?.type === "boolean" ? booleans : category?.type === "string" ? stringOperators : category?.type === "number" ? numberOperators : (category?.type === "date" || category?.type === "dateAsStrings") ? dateOperators : category?.type === 'numberAsString' ? numberAsStringsOperators : category?.type === 'booleanWithoutNull' ? booleansWithoutNull : category?.type === 'qaState' ? qaState : currencyType
                                let showItem = category?.show
                                let defaultSecondData = {}
                                let defaultThirdValue = {}

                                if (savedReport?.primarySupplier && category?.type === "boolean") {
                                    defaultSecondData = booleans?.filter(bool => bool.value === category?.operatorValue)

                                }

                                if (savedReport?.primarySupplier && category?.type === "string") {
                                    defaultSecondData = stringOperators?.filter(bool => bool.value === category?.operatorValue)
                                }

                                if (savedReport?.primarySupplier && (category?.type === "number" || category?.type === "date" || category?.type === "numberAsString")) {
                                    defaultSecondData = numberOperators?.filter(bool => bool.value === category?.operatorValue)
                                }

                                defaultThirdValue = category?.type === "string" ? category?.userInput : category?.type === "number" ? category?.userInputNumber : category?.type === "date" ? category?.userInputDate : ''
                                return (
                                    <div className="w-100 d-flex mt-3" key={category.id} >
                                        <div className="m-4">
                                            <button onClick={() => { onDeleteFilter(index) }} disabled={isSharedReport && true} ><RiDeleteBin5Line size={30} /></button>
                                        </div>
                                        <div className="col-12 d-flex  justify-content-start" >
                                            <div className="d-flex w-100 column-gap-3" >
                                                <Select
                                                    className="col-3"
                                                    styles={{
                                                        control: (baseStyles, state) => ({
                                                            ...baseStyles,
                                                            borderColor: 'grey',
                                                        }),
                                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                                    }}
                                                    menuPortalTarget={document.getElementById("report-parent")}
                                                    classNamePrefix='react-select-selector'
                                                    options={optionsList}
                                                    components={{ Option: CustomOption }}
                                                    value={filterList[index]}
                                                    onChange={(e) => { onChangeFilter(e, index) }}
                                                />
                                                {filterList[index]?.type ?
                                                    (
                                                        <Select
                                                            styles={{
                                                                control: (baseStyles, state) => ({
                                                                    ...baseStyles,
                                                                    borderColor: 'grey',

                                                                }),
                                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                                            }}
                                                            menuPortalTarget={document.body}
                                                            className="col-3"
                                                            classNamePrefix='react-select-selector'
                                                            options={options}
                                                            onChange={(e) => { onChangeOperator(e, index) }}
                                                            value={defaultSecondData?.[0] ? defaultSecondData[0] : (category?.operatorValue !== '' ? {
                                                                label: options?.find(option => option?.value === category?.operatorValue)?.label,
                                                                value: options?.find(option => option?.value === category?.operatorValue)?.value,
                                                                show: options?.find(option => option?.value === category?.operatorValue)?.show
                                                            } : null)}
                                                        />
                                                    ) : null}

                                                {showItem === "string" ?
                                                    (
                                                        <input
                                                            className="search-input w-25  col-3"
                                                            value={category?.userInput ? category?.userInput : ''}
                                                            onChange={(e) => { onUserInput(e, index) }}
                                                        />
                                                    ) : showItem === "amount" ? (
                                                        <input
                                                            style={{ height: 48 }}
                                                            className="search_input w-25 col-3"
                                                            type="number"
                                                            min={0}
                                                            value={category?.userInputNumber ? category?.userInputNumber : ''}
                                                            onChange={(e) => { onUserInput(e, index, 'userInputNumber') }}
                                                        />
                                                    ) : showItem === "date" ? (
                                                        <input
                                                            style={{ height: 48 }}
                                                            className="search_input w-25 col-3"
                                                            type="date"
                                                            min={0}
                                                            options={options}
                                                            onChange={(e) => { onUserInput(e, index, 'userInputDate') }}
                                                            defaultValue={defaultThirdValue}
                                                        />
                                                    ) : showItem === "numberAsString" ? (
                                                        <div className='processing-fee-parent flex'>
                                                            <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                                                                <div className='d-flex'>
                                                                    <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                                                        <Select
                                                                            menuMaxHeight={48}
                                                                            menuPortalTarget={document.getElementById("report-parent")}
                                                                            menuPosition={'fixed'}
                                                                            className="processing-fee-dropdown h4 mb-0 no-zIndex h-100"
                                                                            options={
                                                                                [
                                                                                    {
                                                                                        label: '$',
                                                                                        value: '$',
                                                                                    },
                                                                                    {
                                                                                        label: '%',
                                                                                        value: '%',
                                                                                    },
                                                                                ]
                                                                            }

                                                                            value={defaultThirdValue ? defaultThirdValue : category?.currencyType !== '' ? {
                                                                                label: currencyOptions?.find(option => option?.value === category?.currencyType)?.label,
                                                                                value: currencyOptions?.find(option => option?.value === category?.currencyType)?.value,
                                                                            } : null}
                                                                            onChange={(e) => { onCurrencyChange(e, index) }}
                                                                        />
                                                                        <input
                                                                            className='search-input'
                                                                            onChange={(e) => { onUserInput(e, index, 'userInput') }}
                                                                            value={category?.userInput ? category?.userInput : ''}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='d-none d-sm-block'></div>
                                                        </div>
                                                    )
                                                        : null}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div> : null}
                    </div>
                    <div className="m-2">
                        <button onClick={onAddFilters} >
                            <CiSquarePlus
                                size={50}
                                color="#2196F3"
                            />
                        </button>
                    </div>
                </div>
            </div>
            <div className=" d-flex justify-content-between mt-4">
                <div className="">
                    <h1 className="report_heading">filters applied</h1>
                </div>
                <div className="d-flex column-gap-5">
                    <div className="d-flex column-gap-4 align-items-center">
                        {<VendorExportModal
                            show={exportModal}
                            exportData={exportData}
                            onClose={handleCloseExportModal}
                            fileName={reportName}
                        />}
                        <FaFileExport size={31} color="#959595" onClick={primarySupplier && onExport} />
                        <button
                            className="report_button_secondary"
                            disabled={(primarySupplier === null ? true : false) || loader}
                            onClick={(e) => { onRun(1, limit, offset, primarySupplier[0]?.value, tmpReportId, selectedPartnerOrCustomer, filterList, [], false, genInfoCols, childInfoCols, listSupplierInfoCols, cardAccInfoCols, selectedPartnerList, selectedCustomerList) }}>Run</button>
                        <button className="report_heading_buttons report_button_success" onClick={onSave} disabled={(primarySupplier === null ? true : false) || loader}>Save</button>
                    </div>
                </div>
            </div>

            <ModalComponent
                backdrop={backdrop}
                open={showDialog}
                handleClose={handleClose}
                modalTitle={`Name Of The Report`}
                size={`md`}>
                <>
                    <input className="form-control" style={{ height: 50, fontSize: 18 }} value={reportName} onChange={(e) => { setReportName(e.target.value) }} />
                    <div className="d-flex column-gap-3 mt-4 justify-content-end w-100">
                        <button className="report_button_secondary" onClick={handleClose} >CANCEL</button>
                        <button className="report_heading_buttons report_button_success" disabled={!reportName && true} onClick={onSaveReport}>SAVE</button>
                    </div>
                </>
            </ModalComponent>

            <div
                style={{ overflowY: "auto", height: 'auto', overflowX: 'hidden' }}
                className={`position-relative mt-4 border border-2 rounded ${loader ? 'loading' : ''} `}>
                {/* {loader ? <LoaderComponent /> : null} */}
                <Table
                    virtualized={true}
                    autoHeight
                    affixHeader={true}
                    data={result}
                    id='my-list-table'
                    rowKey="id"
                    loading={loader}
                >
                    {headerElements(tableColHeaders)}
                    <Column
                        width={50}
                        fixed="right"
                        key="action"
                    >
                        <HeaderCell className='fw-bold text-black'>
                            <button className="btn btn-small border ml-2" onClick={(e) => { onOpenPopUp(e) }}> <CiMenuKebab /></button>
                        </HeaderCell>
                        <Cell className='text-black d-none' dataKey={'action'} />
                    </Column>
                </Table>
                <div className="pagination">
                    <Pagination
                        prev
                        next
                        first
                        last
                        showInfo
                        maxButtons={5}
                        lengthMenu={[
                            {
                                label: '5',
                                value: 5,
                            },
                            {
                                label: '10',
                                value: 10,
                            },
                            {
                                label: '25',
                                value: 25,
                            },
                            {
                                label: '50',
                                value: 50,
                            },
                        ]}
                        displayLength={limit}
                        total={totalRecords}
                        limit={limit}
                        activePage={page}
                        onChangePage={onPageChange}
                        onChangeLength={(limit) => { setLimit(limit) }}
                    />
                </div>
            </div>
            <ExportReport
                subGeneralBtnActive={subGeneralBtnActive}
                setSubGeneralBtnActive={setSubGeneralBtnActive}
                onChangeActiveGeneralInfo={onChangeActiveGeneralInfo}
                openReportPopup={openReportPopup}
                setopenReportPopup={setopenReportPopup}
                onSearch={onSearch}
                searchTerm={searchTerm}
                visibleReportHeaders={visibleReportHeaders}
                handleCheckboxChange={handleCheckboxChange}
                active={active}
                setActive={setActive}
                onTabChange={onTabChange}
                genInfoCols={genInfoCols}
                childInfoCols={childInfoCols}
                listSupplierInfoCols={listSupplierInfoCols}
                inSequenceCheckedItems={inSequenceCheckedItems}
                onOpenPopUp={onOpenPopUp}
                cardAccInfoCols={cardAccInfoCols}
                xPos={xPos}
                yPos={yPos}
                onCardAcceptanceTabChange={onCardAcceptanceTabChange}
                cardAcceptanceTab={cardAcceptanceTab}
                masterSupCardAccInfoCols={masterSupCardAccInfoCols}
                primarySupplier={!primarySupplier ? null : primarySupplier[0]?.value}
                headerModal={headerModal}
                setHeaderModal={setHeaderModal}
                backdrop={backdrop}
                onSelectedHeaders={onSelectedHeaders}
                onNotselectedHeaders={onNotselectedHeaders}
                onCloseReportHeader={onCloseReportHeader}
            />
        </div>
    )
}

export default CustomReport;